var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#CBD5E1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 17C23.25 17.1989 23.171 17.3897 23.0303 17.5303C22.8897 17.671 22.6989 17.75 22.5 17.75H17.75V22.5C17.75 22.6989 17.671 22.8897 17.5303 23.0303C17.3897 23.171 17.1989 23.25 17 23.25C16.8011 23.25 16.6103 23.171 16.4697 23.0303C16.329 22.8897 16.25 22.6989 16.25 22.5V17.75H11.5C11.3011 17.75 11.1103 17.671 10.9697 17.5303C10.829 17.3897 10.75 17.1989 10.75 17C10.75 16.8011 10.829 16.6103 10.9697 16.4697C11.1103 16.329 11.3011 16.25 11.5 16.25H16.25V11.5C16.25 11.3011 16.329 11.1103 16.4697 10.9697C16.6103 10.829 16.8011 10.75 17 10.75C17.1989 10.75 17.3897 10.829 17.5303 10.9697C17.671 11.1103 17.75 11.3011 17.75 11.5V16.25H22.5C22.6989 16.25 22.8897 16.329 23.0303 16.4697C23.171 16.6103 23.25 16.8011 23.25 17Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.324df37fd2529d13b8ae982354840226.svg";
export { ForwardRef as ReactComponent };